import ForgetPassword from "./Container"

export default ForgetPassword
